export default __webpack_public_path__ + "static/media/blog-img127.c35fd6b4.jpg";